import * as cmc from './coinmarketcap'
import * as nep5 from './nep5'
import * as core from './core'
import * as modscan from './modscan'
/**
 * @typedef {object} History
 * @property {string} address - Address.
 * @property {string} name - API name.
 * @property {string} net - 'MainNet' or 'TestNet'
 * @property {PastTx[]} history - List of past transactions.
 */

/**
 * @typedef {object} PastTx
 * @property {number} MOD - Module Gas involved.
 * @property {number} MODC - Module Coin involved.
 * @property {number} block_index - Block index.
 * @property {boolean} mod_sent - Was Module Gas sent.
 * @property {boolean} modc_sent - Was Module Coin sent.
 * @property {string} txid - Transaction ID.
 */

export default {
  get: {
    price: cmc.getPrice,
    prices: cmc.getPrices,
    balance: modscan.getBalance,
    // claims: modscan.getClaims,
    transactionHistory: modscan.getTransactionHistory,
    tokenBalance: nep5.getTokenBalance,
    tokenBalances: nep5.getTokenBalances,
    tokenInfo: nep5.getTokenInfo,
    token: nep5.getToken
  },
  do: {
    // sendAsset: modscan.doSendAsset,
    // claimAllGas: modscan.doClaimAllGas,
    // mintTokens: modscan.doMintTokens
  },
  sendAsset: (config) => core.sendAsset(config),
  claimMOD: (config) => core.claimMOD(config),
  doInvoke: (config) => core.doInvoke(config),
  setupVote: (config) => core.setupVote(config)
}

export * from './core'
export { cmc, nep5, modscan }
